export const SendInvitationDataTypes = {
    API_RESPONSE_SUCCESS: '@@SendInvitationData/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@SendInvitationData/API_RESPONSE_ERROR',
    GET_LISTOF_EMAILTEMPLATENAMES: '@@SendInvitationData/GET_LISTOF_EMAILTEMPLATENAMES',
    SEND_INVITATIONSLIST: '@@SendInvitationData/SEND_INVITATIONSLIST',
    SEND_INVITATION: '@@SendInvitationData/SEND_INVITATION',
};
